import challenges from './challenges'
import trainerProfile from './trainerProfile'

const state = {
    isTitle: false,
    title: '',
    isBackButton: false,
    pageName: "",
};

const mutations = {
    setIsTitle(state, isTitle) {
        state.isTitle = isTitle;
    },
    setTitle(state, title) {
        state.title = title;
    },
    setIsBackButton(state, isBackButton) {
        state.isBackButton = isBackButton;
    },
    setPageName(state, pageName) {
        state.pageName = pageName;
    }
};

const getters = {
};

const actions = {
    setIsTitle({ commit }, isTitle) {
        commit("setIsTitle", isTitle);
    },
    setTitle({ commit }, title) {
        commit("setTitle", title);
    },
    setIsBackButton({ commit }, isBackButton) {
        commit("setIsBackButton", isBackButton);
    },
    setPageName({ commit }, pageName) {
        commit("setPageName", pageName);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        challenges,
        trainerProfile
    }
}
